import { keyframes } from '@project44/manifest-ui-deprecated';

const shine = keyframes`
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 500px 500px;
  }
`;

const gradient = `
  linear-gradient(90deg,
    rgba(213, 215, 217, 0.8) 0%,
    #F4F4F4 33%, #F4F4F4 66%,
    rgba(213, 215, 217, 0.8) 100%);
`;

export const SKELETON_BASE = {
  background: gradient,
  backgroundSize: '500px 100%',
  animation: `${shine} 1.8s linear infinite`,
  borderRadius: '9999px',
};
